import {
  Box,
  Button,
  ErrorIcon,
  Flex,
  ListItem,
  ModalContent,
  ModalFooter,
  ModalTitle,
  Text,
} from '@modusign/design-system';
import { useDispatch } from 'react-redux';

import { modalClose } from '@app/store/modal/actions';

export default function LoginFailureModal({ title }: { title: string }) {
  const dispatch = useDispatch();

  return (
    <Flex justifyContent="center" width="100%">
      <Flex p={4} width="xs">
        <Flex
          alignItems="center"
          backgroundColor={'#fff'}
          borderRadius={'3px'}
          boxShadow="0px 60px 40px -30px rgba(0, 0, 0, 0.34902)"
          flexDirection="column"
          pb={8}
          pt={7}
          px={[6, 8]}
          width="100%"
        >
          <ModalTitle direction="column" icon={<ErrorIcon color="iconNegativeBase" />}>
            {title}
          </ModalTitle>
          <ModalContent>
            <Box bg="boxBackgroundNeutralBase" borderRadius="3px" p={6}>
              <Flex as="ul" flexDirection="column" gap={2}>
                {[
                  '올바른 이메일 또는 비밀번호가 아닙니다.',
                  '5회 연속 로그인 실패 시 10분간 로그인이 제한됩니다.',
                ].map((value) => (
                  <ListItem key={value}>
                    <Text whiteSpace="pre-wrap">{value}</Text>
                  </ListItem>
                ))}
              </Flex>
            </Box>
          </ModalContent>
          <ModalFooter>
            <Button
              variant="subtle"
              weight="light"
              onClick={() => {
                dispatch(modalClose());
              }}
            >
              확인
            </Button>
          </ModalFooter>
        </Flex>
      </Flex>
    </Flex>
  );
}
